const MODULE_NAME = 'FEELING_FACTOR_FORM';
const FEELING_FACTOR_SUBMIT_COMPLETED = MODULE_NAME + 'SUBMIT_COMPLETED';

export {
  FEELING_FACTOR_SUBMIT_COMPLETED
};
